'use strict';

import defaultTemplate from '../../core/default.html';
import dashboardPanelTemplate from './dashboard.panel.html';
import usersActivePageTemplate from './pages/usersActivePage/usersActivePage.html';
import usersNewPageTemplate from './pages/usersNewPage/usersNewPage.html';
import subscriptionsTotalPageTemplate from './pages/subscriptionsTotalPage/subscriptionsTotalPage.html';
import locationsTotalPageTemplate from './pages/locationsTotalPage/locationsTotalPage.html';
import subscriptionsPageTemplate from './pages/subscriptionsPage/subscriptionsPage.html';
import alertsPageTemplate from './pages/alertsPage/alertsPage.html';
import devicesTotalPageTemplate from './pages/devicesTotalPage/devicesTotalPage.html';
import gatewaysTotalPageTemplate from './pages/gatewaysTotalPage/gatewaysTotalPage.html';
import gatewaysConnectivityPageTemplate from './pages/gatewaysConnectivityPage/gatewaysConnectivityPage.html';

import Dashboard from './dashboard.ctrl';

function DashboardRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.dashboard', {
      url: '/dashboard',
      template: defaultTemplate,
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard');
        }
      }
    })
    .state('main.dashboard.panel', {
      url: '/panel',
      template: dashboardPanelTemplate,
      controller: 'DashboardPanelController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel');
        }
      }
    })
    .state('main.dashboard.usersActive', {
      url: '/usersActive',
      template: usersActivePageTemplate,
      controller: 'UsersActivePageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.usersActive');
        }
      }
    })
    .state('main.dashboard.usersNew', {
      url: '/usersNew',
      template: usersNewPageTemplate,
      controller: 'UsersNewPageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.newUsers');
        }
      }
    })
    .state('main.dashboard.subscriptionsTotal', {
      url: '/subscriptionsTotal',
      template: subscriptionsTotalPageTemplate,
      controller: 'SubscriptionsTotalPageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.subscriptionsTotal');
        }
      }
    })
    .state('main.dashboard.locationsTotal', {
      url: '/locationsTotal',
      template: locationsTotalPageTemplate,
      controller: 'LocationsTotalPageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.locationsTotal');
        }
      }
    })
    .state('main.dashboard.subscriptions', {
      url: '/subscriptions',
      template: subscriptionsPageTemplate,
      controller: 'SubscriptionsPageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.subscriptions');
        }
      }
    })
    .state('main.dashboard.alerts', {
      url: '/alerts',
      template: alertsPageTemplate,
      controller: 'AlertsPageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.alerts');
        }
      }
    })
    .state('main.dashboard.devicesTotal', {
      url: '/devicesTotal',
      template: devicesTotalPageTemplate,
      controller: 'DevicesTotalPageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.totalDevices');
        }
      }
    })
    .state('main.dashboard.gatewaysTotal', {
      url: '/gatewaysTotal',
      template: gatewaysTotalPageTemplate,
      controller: 'GatewaysTotalPageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.totalGateways');
        }
      }
    })
    .state('main.dashboard.gatewaysConnectivity', {
      url: '/gatewaysConnectivity',
      template: gatewaysConnectivityPageTemplate,
      controller: 'GatewaysConnectivityPageController as vm',
      resolve: {
        permission: ($q, PermissionsService) => {
          return PermissionsService.canIViewDashboard()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.dashboard.panel.totalGateways');
        }
      }
    });
}

export default angular
  .module('dashboard.router', [
    Dashboard
  ])
  .config(DashboardRouter)
  .name;
